import { useMutation } from 'react-query';
import { Http } from '../../services/Http';
import { MUTATION_KEYS } from '../constants';
import { ApprovalDelegate, useInvalidateApprovalDelegates } from './useApprovalDelegates';

export type CreateApprovalDelegatesPayload = {
  dealId: number;
  operatingPartnerIds: number[];
  fromDealOwnerId: number;
  toDealOwnerId: number;
};

async function createApprovalDelegates(
  payload: CreateApprovalDelegatesPayload
): Promise<ApprovalDelegate[]> {
  const { data } = await Http.axios.post<CreateApprovalDelegatesPayload, ApprovalDelegate[]>(
    '/approval-delegate/bulk',
    payload
  );
  return data;
}

/** Create one delegation per operating partner (deal × OP), then refresh lists + deal-owner views. */
export const useCreateApprovalDelegates = () => {
  const invalidate = useInvalidateApprovalDelegates();
  return useMutation(createApprovalDelegates, {
    mutationKey: MUTATION_KEYS.CREATE_APPROVAL_DELEGATES,
    onSuccess: invalidate,
  });
};
